import {
  Box,
  Table
} from '@chakra-ui/react';

import { formatNumber } from "../../../../store/helpers";
import LineGraph from "../../../daily/LineGraph";

const ArrivalRatesPerHourTable = ({ data, index }) => {
  const { total, average, min, max, branchName, chart } = data;

  return (
    <>
      <Box>
        <Table.Root className="stripedTable" size="sm">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>#</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Total Visitors</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Average</Table.ColumnHeader>
              <Table.ColumnHeader>Min</Table.ColumnHeader>
              <Table.ColumnHeader>Max</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>{index + 1}</Table.Cell>
              <Table.Cell borderRight="1px solid #dadce0">{formatNumber(total)}</Table.Cell>
              <Table.Cell borderRight="1px solid #dadce0">{formatNumber(average)}</Table.Cell>
              <Table.Cell>{formatNumber(min)}</Table.Cell>
              <Table.Cell>{formatNumber(max)}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell colSpan={5}>
                <Box mt="20px" mb="20px">
                  <LineGraph
                    chart={chart}
                    title={`${branchName} Arrival rates per hour, Hour by Hour Comparison`}
                  />
                </Box>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table.Root>
      </Box>
    </>
  );
};

export default ArrivalRatesPerHourTable;
